/**
 * DiCon Incident Service API
 * API used by DiCon, LiOn and Buefo.
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: dienstleistung@netze-bw.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Mail object received from incident service
 */
export interface MailTO { 
    subject?: string;
    /**
     * Mail recipients
     */
    recipients: Array<string>;
    /**
     * CC Mail recipients
     */
    recipientCCs?: Array<string>;
    /**
     * Mail reply to address
     */
    replyTo?: string;
    /**
     * Mail reply to name
     */
    replyToName?: string;
    /**
     * Incident UUID
     */
    uuid: string;
    /**
     * Order UUID
     */
    orderUuid?: string;
    /**
     * Dicon domain name
     */
    diconDomain: string;
    /**
     * Priority of the incident
     */
    priority?: string;
    /**
     * Object keys of attachments
     */
    docObjectKeys?: Array<string>;
    /**
     * Light Point number
     */
    lightPointNumber?: string;
    /**
     * Control cabinet number
     */
    controlCabinetNumber?: string;
    /**
     * System type
     */
    systemType: string;
    /**
     * Timestamp of the reported incident
     */
    reportingTimestamp?: string;
    /**
     * Priority due date time
     */
    priorityDueDateTime?: string;
    /**
     * Symptoms of the reported incident
     */
    symptoms?: Array<string>;
    /**
     * Symptom other
     */
    symptomOther?: string;
    /**
     * Street of the reported incident
     */
    street?: string;
    /**
     * House number of the reported incident
     */
    houseNo?: string;
    /**
     * Postal code of the reported incident
     */
    zipCode?: string;
    /**
     * Net area of the reported incident
     */
    netArea?: string;
    /**
     * City of the reported incident
     */
    city?: string;
    /**
     * City district of the reported incident
     */
    cityDistrict?: string;
    /**
     * Further comments on the location of the fault report
     */
    furtherRemarks?: string;
    /**
     * Purchased order number
     */
    purchaseOrderNumber?: string;
    /**
     * Purchased material
     */
    purchaseMaterial?: string;
    /**
     * Resolution date of the material order
     */
    wishResolutionDate?: string;
    /**
     * Citizen\'s comments
     */
    remarksCitizen?: string;
    /**
     * Further comments from the municipality
     */
    remarksMunicipality?: string;
    /**
     * Additional email text
     */
    mailText?: string;
    /**
     * Message UUID
     */
    messageUuid?: string;
    /**
     * Message content
     */
    message?: string;
    /**
     * Answer for the question
     */
    answer?: string;
    /**
     * Person that answered question
     */
    answeredBy?: string;
    /**
     * Arms
     */
    arms?: string;
    /**
     * Poles
     */
    poles?: string;
    /**
     * Luminaires
     */
    luminaires?: string;
    /**
     * Lamps
     */
    lamps?: string;
    /**
     * Cable Number
     */
    cableNumber?: string;
    /**
     * Control Cabinet Number
     */
    controlCabinetNoFromLuxData?: string;
    /**
     * Control Cabinet Description
     */
    controlCabinetDescription?: string;
    /**
     * Trigger Description
     */
    triggerDescription?: string;
    /**
     * Control Cabinet Type
     */
    controlCabinetType?: string;
    /**
     * Is a warning system mounted to the pole?
     */
    warningSystemPresent?: boolean;
    /**
     * WFM Order number
     */
    wfmOrderNumber?: string;
    /**
     * Minze NA SAP number
     */
    minzeNaNumber?: string;
    /**
     * Minze NC SAP number
     */
    minzeNcNumber?: string;
    /**
     * Minze ND SAP number
     */
    minzeNdNumber?: string;
}

